import React from 'react'
import { useParams } from 'react-router-dom';
import useFetch from '../../../hooks/useAxios';
import Button from '../../shared/Button'
import toast from "react-hot-toast";

const CancelRules = ({inforesidencedetail}) => {
  //"normal" //"strict","permissive"
  const {id} = useParams()
  const postCancelreserve = useFetch({
    method: "put",
    url: `api/guest/reserve/cancel/${id}`,
    noHeader: false,
    trigger: false,
    argFunc:res=>{
      
    },
    errMessage:err=>{
      if(err.response.data.message){
        toast.error(err.response.data.message)
      }
    }
  });
  const cancelReserve = ()=>{
    postCancelreserve.reFetch()
  }
  return (
    <div className='CancelRules'>
      <h3>قوانین لغو رزرو</h3>
      <div className='CancelRules-grid'>
        <div className={`CancelRules-grid--box ${inforesidencedetail.regulation.cancel_regulation === "permissive"  ?"CancelRules-grid--box--active" : null}`}>
          <h3>سهل گیرانه</h3>
          <p>در صورتی که رزرو ، ۲۴ ساعت پیش از تاریخ ورود لغو گردد . کل اجاره بها پس از کسر ۱۰ درصد کارمزد لغو ، به میهمان باز پرداخت می گردد .</p>
        </div>
        <div className={`CancelRules-grid--box ${inforesidencedetail.regulation.cancel_regulation === "normal"  ?"CancelRules-grid--box--active" : null}`}>
          <h3>متعادل</h3>
          <p>در صورتی که رزرو ، ۳ روز کامل پیش از تاریخ ورود لغو گردد . کل اجاره بها پس از کسر ۱۰ درصد کارمزد لغو ، به میهمان باز پرداخت می گردد .</p>
        </div>
        <div className={`CancelRules-grid--box ${inforesidencedetail.regulation.cancel_regulation === "strict"  ?"CancelRules-grid--box--active" : null}`}>
          <h3>سخت گیرانه</h3>
          <p>در صورتی که رزرو ، ۵ روز کامل پیش از تاریخ ورود لغو گردد . کل اجاره بها پس از کسر ۲۰ درصد کارمزد لغو ، به میهمان باز پرداخت می گردد .</p>
        </div>

      </div>
      <div className='CancelRules--redbox'>
      قوانین لغو رزرو این اقامتگاه از نوع سهل گیرانه می باشد ، در صورت نیاز با فشردن دکمه زیر ( لغو رزرو ) پیش از تایید میزبان درخواست رزرو خود را لفو نمایید ؛ توجه داشته باشید که تنها یک بار می توانید درخواست رزرو خود را لغو کتید و اقامتگاه دیگری را رزرو نمایید . 
     <div className='flex justify-end'>
     <Button onClick={cancelReserve} varient="primary" className='red-primary-button'>
      لغو رزرو
      </Button>
     </div>
      </div>
    </div>
  )
}

export default CancelRules